
// Based on docs/products-v3 documentation - comprehensive ProductType enum
export enum EProductType {
    WALKING = "WALKING",
    GROOMING = "GROOMING",
    PRODUCTS = "PRODUCTS",
    FOOD = "FOOD",
    TREATS = "TREATS",
    ACCESSORIES = "ACCESSORIES",
    HYGIENE = "HYGIENE",
    MISC = "MISC",
    BEDS = "BEDS",
    APPAREL = "APPAREL",
}

// Based on docs/products-v3 documentation - comprehensive ProductSubType enum
export enum EProductSubType {
    SUBSCRIPTION = "SUBSCRIPTION",
    ONE_TIME = "ONE_TIME",
    PRODUCT = "PRODUCT",
    FOOD_BUNDLE = "FOOD_BUNDLE",
    FOOD_RECIPE = "FOOD_RECIPE",
}

export enum EServiceCategory {
    WALKING = "WALKING",
    GROOMING = "GROOMING",
    TRAINING = "TRAINING",
    PRODUCTS = "PRODUCTS",
}

export enum EServiceType {
    SUBSCRIPTION = "SUBSCRIPTION",
    ONE_TIME = "ONE_TIME",
}

export const PRODUCT_QUERY_KEYS = {
    GET_PRODUCTS: "GET_PRODUCTS",
    GET_PRODUCT_BY_ID: "GET_PRODUCT_BY_ID",
};

/**
 * Product types covered by the "Food and Products" order filter — every backend
 * `ProductType` except the service types `WALKING` and `GROOMING`.
 *
 * Listed explicitly rather than derived from `EProductType`: that enum also carries
 * `PRODUCTS`, which has no backend `ProductType` counterpart (it exists only for the
 * earnings-setup `ServiceCategory` map), and sending it would fail the backend's
 * enum validation and 400 the whole request.
 */
export const NON_SERVICE_PRODUCT_TYPES: EProductType[] = [
    EProductType.FOOD,
    EProductType.TREATS,
    EProductType.ACCESSORIES,
    EProductType.HYGIENE,
    EProductType.MISC,
    EProductType.BEDS,
    EProductType.APPAREL,
];
